/**
 * @generated SignedSource<<7c042afa52c1da6920909c827a9024af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type usePdpPricingAndSaleVariant_item$data = {
  readonly isSold: boolean | null;
  readonly isUnpurchasable: boolean | null;
  readonly " $fragmentType": "usePdpPricingAndSaleVariant_item";
};
export type usePdpPricingAndSaleVariant_item$key = {
  readonly " $data"?: usePdpPricingAndSaleVariant_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePdpPricingAndSaleVariant_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "usePdpPricingAndSaleVariant_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSold",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isUnpurchasable",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "a1dd0c63700d09640a1093f2fd39c4c5";

export default node;
